// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основные стили */
body {
    background-color: #396687;
    color: #e0e0e0;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
  }
  
  /* Основной контейнер чата */
  .chat-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    max-width: 600px;
    margin: 0 auto;
    background-color: #2d4d66;
    border-radius: 8px;
    overflow: hidden;
  }
  
  /* Заголовок чата */
  .chat-header {
    padding: 15px;
    background-color: #3c91cf;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  /* Статус подключения */
  .connection-status {
    font-size: 0.9em;
    padding: 4px 8px;
    border-radius: 12px;
  }
  
  .connection-status.connected {
    background-color: #4caf50;
  }
  
  .connection-status.disconnected {
    background-color: #e53935;
  }
  
  /* Список сообщений */
  .messages-list {
    flex: 1 1;
    overflow-y: auto;
    padding: 15px;
    background-color: #2d4d66;
  }
  
  /* Сообщение */
  .message {
    margin: 8px 0;
    padding: 10px 15px;
    border-radius: 8px;
    max-width: 70%;
    word-wrap: break-word;
  }
  
  /* Сообщения от текущего пользователя */
  .sent {
    background-color: #3c91cf;
    color: white;
    margin-left: auto;
    border-bottom-right-radius: 0;
  }
  
  /* Сообщения от другого пользователя */
  .received {
    background-color: rgba(255, 255, 255, 0.1);
    margin-right: auto;
    border-bottom-left-radius: 0;
  }
  
  /* Контент сообщения */
  .message-content {
    display: flex;
    flex-direction: column;
  }
  
  /* Время сообщения */
  .message-time {
    font-size: 0.7em;
    opacity: 0.8;
    margin-top: 5px;
  }
  
  .sent .message-time {
    color: rgba(255, 255, 255, 0.7);
  }
  
  .received .message-time {
    color: rgba(255, 255, 255, 0.6);
  }
  
  /* Форма для ввода сообщения */
  .message-form {
    display: flex;
    padding: 10px;
    background-color: #2d4d66;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  /* Поле ввода сообщения */
  .message-input {
    flex: 1 1;
    padding: 10px 15px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    margin-right: 10px;
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
  }
  
  .message-input:focus {
    outline: none;
    border-color: #3c91cf;
  }
  
  /* Кнопка отправки */
  .send-button {
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    background-color: #3c91cf;
    color: white;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .send-button:hover {
    background-color: #2e7ab3;
  }
  
  .send-button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
  
  /* Элементы загрузки и ошибки */
  .chat-loading,
  .chat-error {
    padding: 20px;
    text-align: center;
    color: white;
  }
  
  .chat-error {
    color: #ff6b6b;
  }
  
  /* Сообщение о пустом чате */
  .no-messages {
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
    padding: 20px;
  }
  
  /* Полоса прокрутки */
  .messages-list::-webkit-scrollbar {
    width: 6px;
  }
  
  .messages-list::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
  }
  
  .messages-list::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }`, "",{"version":3,"sources":["webpack://./src/components/css/Chat.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,cAAc;IACd,8BAA8B;IAC9B,SAAS;IACT,UAAU;EACZ;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,uBAAuB;EACvB;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,yBAAyB;EAC3B;;EAEA,cAAc;EACd;IACE,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;EACvB;;EAEA,uCAAuC;EACvC;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA,sCAAsC;EACtC;IACE,0CAA0C;IAC1C,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,8CAA8C;EAChD;;EAEA,yBAAyB;EACzB;IACE,SAAO;IACP,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;EACd;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,+BAA+B;EAC/B;;IAEE,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA,4BAA4B;EAC5B;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,UAAU;EACZ;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB","sourcesContent":["/* Основные стили */\nbody {\n    background-color: #396687;\n    color: #e0e0e0;\n    font-family: Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n  }\n  \n  /* Основной контейнер чата */\n  .chat-container {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    max-width: 600px;\n    margin: 0 auto;\n    background-color: #2d4d66;\n    border-radius: 8px;\n    overflow: hidden;\n  }\n  \n  /* Заголовок чата */\n  .chat-header {\n    padding: 15px;\n    background-color: #3c91cf;\n    color: white;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  /* Статус подключения */\n  .connection-status {\n    font-size: 0.9em;\n    padding: 4px 8px;\n    border-radius: 12px;\n  }\n  \n  .connection-status.connected {\n    background-color: #4caf50;\n  }\n  \n  .connection-status.disconnected {\n    background-color: #e53935;\n  }\n  \n  /* Список сообщений */\n  .messages-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 15px;\n    background-color: #2d4d66;\n  }\n  \n  /* Сообщение */\n  .message {\n    margin: 8px 0;\n    padding: 10px 15px;\n    border-radius: 8px;\n    max-width: 70%;\n    word-wrap: break-word;\n  }\n  \n  /* Сообщения от текущего пользователя */\n  .sent {\n    background-color: #3c91cf;\n    color: white;\n    margin-left: auto;\n    border-bottom-right-radius: 0;\n  }\n  \n  /* Сообщения от другого пользователя */\n  .received {\n    background-color: rgba(255, 255, 255, 0.1);\n    margin-right: auto;\n    border-bottom-left-radius: 0;\n  }\n  \n  /* Контент сообщения */\n  .message-content {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Время сообщения */\n  .message-time {\n    font-size: 0.7em;\n    opacity: 0.8;\n    margin-top: 5px;\n  }\n  \n  .sent .message-time {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  \n  .received .message-time {\n    color: rgba(255, 255, 255, 0.6);\n  }\n  \n  /* Форма для ввода сообщения */\n  .message-form {\n    display: flex;\n    padding: 10px;\n    background-color: #2d4d66;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  /* Поле ввода сообщения */\n  .message-input {\n    flex: 1;\n    padding: 10px 15px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 20px;\n    margin-right: 10px;\n    background-color: rgba(255, 255, 255, 0.1);\n    color: white;\n  }\n  \n  .message-input:focus {\n    outline: none;\n    border-color: #3c91cf;\n  }\n  \n  /* Кнопка отправки */\n  .send-button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 20px;\n    background-color: #3c91cf;\n    color: white;\n    cursor: pointer;\n    transition: background-color 0.2s;\n  }\n  \n  .send-button:hover {\n    background-color: #2e7ab3;\n  }\n  \n  .send-button:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n  }\n  \n  /* Элементы загрузки и ошибки */\n  .chat-loading,\n  .chat-error {\n    padding: 20px;\n    text-align: center;\n    color: white;\n  }\n  \n  .chat-error {\n    color: #ff6b6b;\n  }\n  \n  /* Сообщение о пустом чате */\n  .no-messages {\n    text-align: center;\n    color: rgba(255, 255, 255, 0.6);\n    padding: 20px;\n  }\n  \n  /* Полоса прокрутки */\n  .messages-list::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  .messages-list::-webkit-scrollbar-track {\n    background: rgba(255, 255, 255, 0.05);\n  }\n  \n  .messages-list::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.2);\n    border-radius: 3px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
